import './index.css'
import './utils/disableOverlay'

import App from './App.vue'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { errorHandler } from './services/error/errorHandler'
import { logger } from './utils/logger'
import router from './router/index'
import { validateConfig } from './utils/configValidator'

// Validate configuration before starting the application
validateConfig()

// Init function
async function init() {
  // Create the app instance
  const app = createApp(App)

  // Initialize Pinia
  const pinia = createPinia()
  app.use(pinia)

  // Initialize router
  app.use(router)

  // Global error handler
  app.config.errorHandler = (error, instance, info) => {
    logger.error('Global error:', { error, instance, info })
    errorHandler.setError(error, 'Global Vue Error')
  }

  // Mount the app
  app.mount('#app')
}

// Start the application
init()
